// Japan
export const locale = {};
